// Japan
export const locale = {};
